// extracted by mini-css-extract-plugin
export default {"companyContainer":"nM-z","companyImage":"oM-z","container":"pM-z","heading":"qM-z","darkText":"rM-z","smallHeading":"sM-z","darkBackground":"tM-z","whiteBackground":"uM-z"};